import React from 'react';
import { heroData, contactData } from '../data/mock';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-3 gap-10">
          {/* Logo UNIFOCO (discreto) and Description */}
          <div className="space-y-4">
            <div className="text-white/80">
              <span className="text-2xl font-bold tracking-wider">UNIFOCO</span>
              <span className="block text-sm opacity-70 mt-1">Formação e Ensino Profissional, Lda</span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed">
              Formação superior em Gestão, Tecnologia e Cibersegurança — orientada para o futuro digital.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-xl mb-5">Ligações Rápidas</h4>
            <ul className="space-y-3">
              {['Início', 'Quem Somos', 'Cursos', 'Contactos'].map((item, index) => (
                <li key={index}>
                  <a
                    href={`#${['hero', 'about', 'courses', 'contact'][index]}`}
                    className="text-white/60 hover:text-[#DA8347] transition-colors duration-200"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-xl mb-5">Contactos</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3 text-white/60">
                <MapPin size={18} className="flex-shrink-0 text-[#DA8347]" />
                <span>{contactData.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-[#DA8347] flex-shrink-0" />
                <a
                  href={`mailto:${contactData.email}`}
                  className="text-white/60 hover:text-[#DA8347] transition-colors duration-200"
                >
                  {contactData.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-[#DA8347] flex-shrink-0" />
                <a
                  href={`tel:${contactData.phone.replace(/\s/g, '')}`}
                  className="text-white/60 hover:text-[#DA8347] transition-colors duration-200"
                >
                  {contactData.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-14 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/40 text-sm">
              © {currentYear} {contactData.institution}. Todos os direitos reservados.
            </p>
            <p className="text-white/40 text-sm">
              Instituto Politécnico de Tecnologia e Gestão de Espinho
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
